<template>
<b-sidebar
  right
  shadow
  v-model="show"
  backdrop
  class="sidebar-contents"
>
  <div>
    <h4 class="text-center mb-2">{{$t('campaigns.titleSide')}}</h4>
    <div class="d-flex flex-column">

      <b-col class="col-12 mb-1">
        <b-input-group class="my-1">
          <b-form-input
            v-model="search"
            placeholder="Buscar influencer"
            @input="getCampaignManage($event)"
            @keydown.enter.prevent="selectFirst"
            autocomplete="off"
          />
          <b-input-group-append>
            <b-button
              @click="selectFirst()"
              class="blue-button"
              variant="blue-button"
            >
             agregar
            </b-button>
          </b-input-group-append>
        </b-input-group>

        <!-- Resultados -->
        <b-list-group
          v-if="search && !selected_influencers"
          class="container-table-influencers"
        >
          <b-list-group-item v-if="loading" class="text-blue text-center">
            <b-spinner small type="grow" class="mr-1"></b-spinner> Buscando...
          </b-list-group-item>

          <b-list-group-item
            v-for="(item, index) in influencers"
            :key="index"
            class="d-flex align-items-center cursor-pointer"
            button
            @click="selectInfluencer(item)"
          >
            <div class="position-relative">
              <b-avatar
                size="40px"
                variant="light-primary"
                class="mr-1"
                :src="item.influencer.image_url"
              />
              <b-avatar
                size="20px"
                class="mr-1 container-avatar-table-icon"
                variant="light"
              >
                <b-img
                  :src="getIconWhite(item.influencer.network)"
                  :class="getIconColor(item.influencer.network, false)"
                  fluid
                />
              </b-avatar>
            </div>
            <div class="d-flex flex-column">
              <div class="font-weight-bold">@{{ item.influencer.username }}</div>
              <small class="text-muted">
                {{ getFormat(item.influencer.followers) }} Seguidores
              </small>
            </div>
          </b-list-group-item>

          <b-list-group-item
            v-if="!loading && influencers.length === 0"
            class="text-muted text-center"
          >
            {{ $t("campaigns.noResults") }}
          </b-list-group-item>
        </b-list-group>

        <!-- Seleccionado -->
        <div class="my-2" v-if="selected_influencers">
          <b-link class="influencer-link d-flex align-items-center mr-05 mt-1">
            <b-avatar
              size="20px"
              variant="light-primary"
              class="mr-05"
              :src="selected_avatar"
            />
            <span class="username">{{ selected_influencers }}</span>
            <b-button
              size="sm"
              variant="link"
              class="remove-btn ml-05 p-0"
              @click="removeUser"
            >
              &times;
            </b-button>
          </b-link>
        </div>
      </b-col>
 
      <b-col class="col-12 mb-1">
        <b-dropdown
          :text="$t(select_text_default)"
          :class="`w-md-75 w-100 dropdownNet ${select_text_default !== 'default_select_net' ? 'p-auto' : ''}`"
          v-model="content.network"
          variant="outline"
          menu-class="submenu"
          no-caret
          no-flip
        >
          <template #button-content>
            <template v-if="select_text_default !== 'default_select_net'">
              <b-avatar variant="light" size="20" class="bg-danger">
                <b-img
                  :src="getDropdownNetworks().find((item) => item.value === select_text_default.toLowerCase()).icon" 
                  :class="getIconColor(select_text_default.toLowerCase(), false)"
                  fluid
                />
              </b-avatar>
            </template>
            <span class="text-default-networks-modal">
              {{$t(select_text_default)}}
            </span>
          </template>

          <b-dropdown-item
            v-for="item in getDropdownNetworks()"
            :key="item.value"
            @click="dropdownItemClick(item)"
          >
            <b-avatar variant="light" size="20">
              <b-img 
                :src="item.icon"
                :class="getIconColor(item.network.toLowerCase(), false)"
                fluid
              />
            </b-avatar>
            <span>{{ item.network }}</span>
          </b-dropdown-item>
        </b-dropdown>
      </b-col>

      <b-col class="col-12 mb-1">
        <v-select
          v-model="content.content_type"
          :options="options_types"
          value-field="value"
          text-field="label"
          :reduce="option => option.value"
          :placeholder="this.$t('select_net')"
        />
      </b-col>

    </div>

    <hr class="mb-1" />
      <h4 class="text-center">{{ $t("campaigns.metrics_text") }}</h4>

    <div class="px-1">
      <general-form
        :content_dad="content"
        :uuids="{ campaign_uuid, campaign_influencer }"
        :net="content.network"
        :show_date_publish="true"
        @closeModal="onSubmit"
        :is_content_new="true"
        @send_blob_preview="onBlobPreview"
        :code_campaign="code_campaign"
      />
    </div>

  </div>
</b-sidebar>

</template>

<script>
import { BSidebar, BCol, BDropdown, BDropdownItem, BAvatar, BImg, BInputGroup, BFormInput, BInputGroupAppend, BButton, BLink, BListGroup, BListGroupItem, BSpinner,} from 'bootstrap-vue';
import { getDropdownNetworks, getIconColor, getIconWhite } from '@/libs/utils/icons';
import { capitalize, getFormat, trimText } from '@/libs/utils/formats';
import vSelect from 'vue-select';
import manage_invitation from "@/services/invitation";
import { showToast } from '@/libs/utils/others';
import GeneralForm from "@/views/pages/invitation/newInvitation/forms/GeneralForm.vue";
import axios from 'axios'
import config from '@/services/config'
import {tokenExpired} from '@/auth/utils'

export default {
  name: 'sidebarContent',
  components: {
    GeneralForm,
    BSidebar,
    BCol,
    BDropdown,
    BDropdownItem,
    BAvatar,
    BImg,
    vSelect,
    BInputGroup,
    BFormInput,
    BInputGroupAppend,
    BButton,
    BLink,
    BListGroup,
    BListGroupItem,
    BSpinner,
  },
  props: {
    content_dad: {
      type: Object,
      required: true,
    },
    campaign_uuid: {
      type: String,
      required: true,
    },
    campaign_influencer: {
      type: String,
      required: true,
    },
    code_campaign: {
      type: String,
      default: null
    },
    show_side: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      trimText,
      blob_preview: null,
      cancel_campaign_request: null,
      searchTimeout: null,
      show: this.show_side,
      content: { ...this.content_dad },
      search: "",
      influencers: [],
      loading: false,
      selected_influencers: null,
      selected_avatar: null,
      type_contents : [
        {
          value: "instagram",
          types: [
            { value: "reel", label: "Reel" },
            { value: "story", label: "Story" },
            { value: "photo", label: this.$t('invitation.photo') },
            { value: "video", label: "Video" },
            { value: "streaming", label: "Live stream" },
          ],
        },
        {
          value: "youtube",
          types: [
            { value: "video", label: "Video" },
            { value: "streaming", label: "Live stream" },
            { value: "reel", label: "Short" },
          ],
        },
        {
          value: "tiktok",
          types: [
            { value: "reel", label: "TikTok" },
            { value: "story", label: "Story" },
            { value: "streaming", label: "Live stream" },
          ],
        },
        {
          value: "facebook",
          types: [
            { value: "post", label: "Post" },
            { value: "photo", label: this.$t('invitation.photo') },
            { value: "reel", label: "Reel" },
            { value: "video", label: "Video" },
            { value: "streaming", label: "Live stream" },
          ],
        },
        {
          value: "twitter",
          types: [
            { value: "post", label: "Post" },
            { value: "photo", label: this.$t('invitation.photo') },
            { value: "reel", label: "Reel" },
            { value: "video", label: "Video" },
            { value: "streaming", label: "Live stream" },
          ],
        },
        {
          value: "linkedin",
          types: [
            { value: "post", label: "Post" },
            { value: "photo", label: this.$t('invitation.photo') },
            { value: "video", label: "Video" },
            { value: "streaming", label: "Live stream" },
          ],
        },
        {
          value: "spotify",
          types: [{ value: "podcast", label: "Podcast" }],
        },
        {
          value: "twitch",
          types: [
            { value: "streaming", label: "Live stream" },
            { value: "clip", label: "Clip" }
          ],
        },
        {
          value: "pinterest",
          types: [
            { value: "photo", label: this.$t('invitation.photo') },
            { value: "video", label: "Video" },
          ],
        },
        {
          value: "blog",
          types: [{ value: "post", label: "Blog Post" }],
        },
        {
          value: "snapchat",
          types: [
            { value: "story", label: "Story" },
            { value: "reel", label: "Spotlight" },
          ],
        },
      ],
      options_types: [],
      select_text_default: 'default_select_net',
      capitalize,
      getIconWhite,
      getIconColor,
      getDropdownNetworks,
      getFormat,
    }
  },
  methods: {
    onBlobPreview(blob) {
      this.blob_preview = blob
    },
    onSubmit(updatedContent) {
      this.content = { ...updatedContent, campaign_influencer: this.content.campaign_influencer }

      const form = new FormData()
      form.append("status", "content_published")
      form.append("campaign_influencer", this.content.campaign_influencer)

      form.append("network", this.content.network)
      form.append("content_type", this.content.content_type?.value || this.content.content_type)
      form.append("published_date", this.content.published_date)
      form.append("estimated_cost", 0)
      form.append("number_repeat", 1)

      form.append("number_of_views", this.content.number_of_views)
      form.append("number_of_impressions", this.content.number_of_impressions)
      form.append("number_of_likes", this.content.number_of_likes)
      form.append("number_of_comments", this.content.number_of_comments)
      form.append("number_of_shares", this.content.number_of_shares)
      form.append("number_of_times_saved", this.content.number_of_times_saved)

      if (this.content.content_type === "story") {
        if (this.content.image_content) {
          form.append("image_content", this.content.image_content)
        }
        if (this.blob_preview) {
          form.append("blob_preview", this.blob_preview)
        }
      } else {
        form.append("url_info", this.content.url_info || "")
      }

      manage_invitation.addContent(this.$route.params.uuid, form)
        .then((response) => {
          if (response.uuid) {
            this.$emit("update_contents")
            this.blob_preview = null
            showToast(this, "success", "CheckCircleIcon", "campaigns.titleContentPublished")
          } else {
            showToast(this, "danger", "BellIcon", "campaigns.titleErrorContent")
          }
        })
        .catch((err) => {
          showToast(this, "danger", "BellIcon", "campaigns.titleErrorContent", err)
        })
    },
    getCampaignManage(query, page = 1, size_page = 100) {
      if (this.searchTimeout) clearTimeout(this.searchTimeout);

      if (!query) {
        this.loading = false;
        this.influencers = [];
        return;
      }

      this.loading = true;

      const CancelToken = axios.CancelToken;
      if (this.cancel_campaign_request) this.cancel_campaign_request();

      this.searchTimeout = setTimeout(() => {
        axios({
          method: "get",
          url: `${config.urlCore}/api/v1/campaign/${this.$route.params.uuid}/manage/`,
          params: {
            query: trimText(query),
            page,
            size_page,
          },
          headers: {
            Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
          },
          cancelToken: new CancelToken((c) => {
            this.cancel_campaign_request = c;
          }),
        })
          .then((response) => {
        
            this.influencers = response.data.response.results ?? [];

          })
          .catch((error) => {
            if (axios.isCancel(error)) {
              console.log("Petición cancelada getCampaignManage");
            } else if (error.response?.status === 401) {
              tokenExpired();
            }
          })
          .finally(() => {
            this.loading = false;
          });
      }, 300);
    },

    selectInfluencer(item) {
      this.selected_influencers = item.influencer.username;
      this.content.selected_influencers = item.influencer.username;
      this.content.selected_influencers_network = item.influencer.network;
      this.selected_avatar = item.influencer.image_url;
      this.content.campaign_influencer = item.uuid;
      this.search = "";
      this.influencers = [];
    },

    removeUser() {
      this.selected_influencers = null;
      this.content.selected_influencers = null;
      this.content.selected_influencers_network = null;
      this.selected_avatar = null;
      this.content.campaign_influencer = null;
    },

    selectFirst() {
      if (this.influencers.length > 0) {
        this.selectInfluencer(this.influencers[0]);
      }
    },
    dropdownItemClick(net) {
      this.select_text_default = net.network
      this.content.network = net.value

      const type = this.type_contents.find(item => item.value === this.content.network)
      this.options_types = type.types

      const currentType = type.types.find(t => t.value === this.content.content_type)

      this.content.content_type = currentType ? currentType.value : type.types[0].value
    },
  }
}
</script>

<style>
.avatar-absolute-sider {
  position: absolute;
  left:4px
}
.img-network{
  height: 35px !important;
  width: 35px !important;
  position: relative;
  bottom: -10em;
  right: 3em;
}
.b-sidebar-backdrop {
  background-color: transparent !important;
}
.sidebar-contents > .b-sidebar {
  width: 500px !important;
}
</style>
<style scoped lang="scss">
.container-table-influencers {
  max-height: 250px;
  overflow-y: auto;
}
.container-avatar-table-icon {
  position: absolute; 
  bottom: -5px; 
  right: 0px;
}
.influencer-link {
  color: black;
  text-decoration: none;
}

.influencer-link:hover {
  color: #0096fe;
}

.influencer-link .remove-btn {
  color: black;
  display: none;
}

.influencer-link:hover .remove-btn {
  color: #0096fe;
  display: inline-block;
}
.dropdownNet {
  border: 1px solid #D8D6DE;
  border-radius: 0.3em;
  li {
    .b-avatar {
      margin-right: 0.7em;
    }
  }
}
.p-auto .btn {
  padding: 0.6em !important;
}
.dropdownNet:focus-within{
  border: none;
}
</style>